import React from 'react';

const ListItemFields = ({
  items = [],
  onChange,
  onAdd,
  onRemove,
  itemLabel = 'Item',
  addLabel = 'Add item'
}) => (
  <div className="page-content-list-fields">
    {items.map((item, index) => (
      <div key={`${itemLabel}-${index}`} className="page-content-list-item">
        <label className="admin-form-label">{itemLabel} {index + 1}</label>
        <div className="page-content-list-item-row">
          <input
            type="text"
            className="admin-form-input"
            value={item}
            onChange={(e) => onChange(index, e.target.value)}
          />
          <button
            type="button"
            className="page-content-list-remove"
            onClick={() => onRemove(index)}
            aria-label={`Remove ${itemLabel} ${index + 1}`}
          >
            Remove
          </button>
        </div>
      </div>
    ))}
    <button type="button" className="page-content-list-add" onClick={onAdd}>
      {addLabel}
    </button>
  </div>
);

export default ListItemFields;
